import React from 'react'

import * as styles from './article-wrapper.module.css'

const HeroMiniAdSpace = ({children}) => {
  return (
        <div className={styles.heroMiniAd}>
            <div className={styles.adSpace300x}>Advertisement</div>
            <div className={styles.adSpace250x}>Advertisement</div>
        </div>
  )
}

export default HeroMiniAdSpace
